/**
 * Handles numeric input validation and formatting
 * @param {string} value - The input value to validate
 * @param {Function} setter - State setter function to update the value
 * @returns {void}
 */
export const handleNumberInput = (value, setter) => {
    // Allow empty string for clearing the input
    if (value === "") {
        setter("");
        return;
    }

    // Only allow valid numbers
    const numberValue = value.replace(/[^.-\d]/g, '');
    if (numberValue === "" || numberValue === "-" || numberValue === ".") {
        setter(numberValue);
    } else {
        setter(numberValue);
    }
};

/**
 * Validates if a value is a valid number or empty string
 * @param {string} value - The value to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const isValidNumberInput = (value) => {
    if (value === "" || value === "-" || value === ".") return true;
    return !isNaN(value) && value !== null;
};